import React from 'react';
import styles from '../../Home.module.css';

const StatStrip = () => (
  <section className={styles.strip}>
    <div className={`${styles.container} ${styles.stripInner}`}>
      <div className={styles.stripLab}>Built for independent businesses across the U.S.</div>
      <div className={styles.stats}>
        <div><div className={styles.statN}>4</div><div className={styles.statL}>ways to get paid</div></div>
        <div><div className={styles.statN}>~2 days</div><div className={styles.statL}>to your account</div></div>
        <div><div className={styles.statN}>∞</div><div className={styles.statL}>invoices &amp; links</div></div>
        <div><div className={styles.statN}>$0</div><div className={styles.statL}>to start</div></div>
      </div>
    </div>
  </section>
);

export default StatStrip;
